import _styled from "styled-components";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ModalHeader(_ref) {
  var children = _ref.children,
      variant = _ref.variant,
      onClose = _ref.onClose;

  switch (variant) {
    case 'mobile-with-title':
      return /*#__PURE__*/_jsx(_StyledDiv, {
        children: /*#__PURE__*/_jsxs(_StyledDiv2, {
          children: [/*#__PURE__*/_jsx(_StyledDiv3, {}), /*#__PURE__*/_jsx(_StyledDiv4, {
            children: children
          })]
        })
      });

    case 'mobile-without-title':
      return /*#__PURE__*/_jsxs(_StyledDiv5, {
        children: [/*#__PURE__*/_jsx(_StyledDiv6, {
          children: /*#__PURE__*/_jsx(_StyledDiv7, {})
        }), ' ']
      });

    case 'desktop-with-title-close-button':
      return /*#__PURE__*/_jsxs(_StyledDiv8, {
        children: [/*#__PURE__*/_jsx(_StyledDiv9, {
          children: /*#__PURE__*/_jsx(_StyledButton, {
            type: "button",
            "aria-label": "Close",
            onClick: onClose,
            children: /*#__PURE__*/_jsx("svg", {
              width: "20",
              height: "20",
              viewBox: "0 0 20 20",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: /*#__PURE__*/_jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.29303 4.29302C4.48056 4.10555 4.73487 4.00023 5.00003 4.00023C5.26519 4.00023 5.5195 4.10555 5.70703 4.29302L10 8.58602L14.293 4.29302C14.3853 4.19751 14.4956 4.12133 14.6176 4.06892C14.7396 4.01651 14.8709 3.98892 15.0036 3.98777C15.1364 3.98662 15.2681 4.01192 15.391 4.0622C15.5139 4.11248 15.6255 4.18673 15.7194 4.28062C15.8133 4.37452 15.8876 4.48617 15.9379 4.60907C15.9881 4.73196 16.0134 4.86364 16.0123 4.99642C16.0111 5.1292 15.9835 5.26042 15.9311 5.38242C15.8787 5.50443 15.8025 5.61477 15.707 5.70702L11.414 10L15.707 14.293C15.8892 14.4816 15.99 14.7342 15.9877 14.9964C15.9854 15.2586 15.8803 15.5094 15.6948 15.6948C15.5094 15.8802 15.2586 15.9854 14.9964 15.9877C14.7342 15.99 14.4816 15.8892 14.293 15.707L10 11.414L5.70703 15.707C5.51843 15.8892 5.26583 15.99 5.00363 15.9877C4.74143 15.9854 4.49062 15.8802 4.30521 15.6948C4.1198 15.5094 4.01463 15.2586 4.01236 14.9964C4.01008 14.7342 4.11087 14.4816 4.29303 14.293L8.58603 10L4.29303 5.70702C4.10556 5.51949 4.00024 5.26518 4.00024 5.00002C4.00024 4.73486 4.10556 4.48055 4.29303 4.29302Z",
                fill: "#9CA3AF"
              })
            })
          })
        }), children && /*#__PURE__*/_jsx(_StyledDiv10, {
          children: children
        })]
      });

    case 'desktop-with-title-close-button-inline':
      return /*#__PURE__*/_jsx(_StyledDiv11, {
        children: /*#__PURE__*/_jsxs(_StyledDiv12, {
          children: [/*#__PURE__*/_jsx(_StyledButton2, {
            type: "button",
            "aria-label": "Close",
            onClick: onClose,
            children: /*#__PURE__*/_jsx("svg", {
              width: "20",
              height: "20",
              viewBox: "0 0 20 20",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: /*#__PURE__*/_jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.29303 4.29302C4.48056 4.10555 4.73487 4.00023 5.00003 4.00023C5.26519 4.00023 5.5195 4.10555 5.70703 4.29302L10 8.58602L14.293 4.29302C14.3853 4.19751 14.4956 4.12133 14.6176 4.06892C14.7396 4.01651 14.8709 3.98892 15.0036 3.98777C15.1364 3.98662 15.2681 4.01192 15.391 4.0622C15.5139 4.11248 15.6255 4.18673 15.7194 4.28062C15.8133 4.37452 15.8876 4.48617 15.9379 4.60907C15.9881 4.73196 16.0134 4.86364 16.0123 4.99642C16.0111 5.1292 15.9835 5.26042 15.9311 5.38242C15.8787 5.50443 15.8025 5.61477 15.707 5.70702L11.414 10L15.707 14.293C15.8892 14.4816 15.99 14.7342 15.9877 14.9964C15.9854 15.2586 15.8803 15.5094 15.6948 15.6948C15.5094 15.8802 15.2586 15.9854 14.9964 15.9877C14.7342 15.99 14.4816 15.8892 14.293 15.707L10 11.414L5.70703 15.707C5.51843 15.8892 5.26583 15.99 5.00363 15.9877C4.74143 15.9854 4.49062 15.8802 4.30521 15.6948C4.1198 15.5094 4.01463 15.2586 4.01236 14.9964C4.01008 14.7342 4.11087 14.4816 4.29303 14.293L8.58603 10L4.29303 5.70702C4.10556 5.51949 4.00024 5.26518 4.00024 5.00002C4.00024 4.73486 4.10556 4.48055 4.29303 4.29302Z",
                fill: "#9CA3AF"
              })
            })
          }), /*#__PURE__*/_jsx(_StyledDiv13, {
            children: children
          })]
        })
      });

    default:
      return /*#__PURE__*/_jsx(_StyledDiv14, {
        children: children
      });
  }
}
export default ModalHeader;

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "modal-header___StyledDiv",
  componentId: "sc-6gq9eh-0"
})({
  "width": "100%"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "modal-header___StyledDiv2",
  componentId: "sc-6gq9eh-1"
})({
  "display": "flex",
  "minHeight": "46px",
  "width": "100%",
  "touchAction": "none",
  "flexDirection": "column",
  "alignItems": "center",
  "justifyContent": "center",
  "paddingBottom": "12px"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "modal-header___StyledDiv3",
  componentId: "sc-6gq9eh-2"
})({
  "marginTop": "12px",
  "display": "flex",
  "width": "42px",
  "borderRadius": "0.25rem",
  "borderWidth": "2px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(209 213 219 / var(--tw-border-opacity))"
});

var _StyledDiv4 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "modal-header___StyledDiv4",
  componentId: "sc-6gq9eh-3"
})({
  "width": "100%",
  "paddingTop": "20px"
});

var _StyledDiv5 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "modal-header___StyledDiv5",
  componentId: "sc-6gq9eh-4"
})({
  "width": "100%"
});

var _StyledDiv6 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "modal-header___StyledDiv6",
  componentId: "sc-6gq9eh-5"
})({
  "display": "flex",
  "minHeight": "46px",
  "width": "100%",
  "touchAction": "none",
  "justifyContent": "center"
});

var _StyledDiv7 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "modal-header___StyledDiv7",
  componentId: "sc-6gq9eh-6"
})({
  "marginTop": "16px",
  "marginBottom": "16px",
  "display": "flex",
  "width": "42px",
  "alignSelf": "center",
  "borderRadius": "0.25rem",
  "borderWidth": "2px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(209 213 219 / var(--tw-border-opacity))"
});

var _StyledDiv8 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "modal-header___StyledDiv8",
  componentId: "sc-6gq9eh-7"
})({
  "width": "100%"
});

var _StyledDiv9 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "modal-header___StyledDiv9",
  componentId: "sc-6gq9eh-8"
})({
  "display": "flex",
  "justifyContent": "flex-end",
  "paddingLeft": "16px",
  "paddingRight": "16px",
  "paddingBottom": "0px",
  "paddingTop": "16px"
});

var _StyledButton = /*#__PURE__*/_styled("button").withConfig({
  displayName: "modal-header___StyledButton",
  componentId: "sc-6gq9eh-9"
})({
  ":hover": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(243 244 246 / var(--tw-bg-opacity))"
  }
});

var _StyledDiv10 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "modal-header___StyledDiv10",
  componentId: "sc-6gq9eh-10"
})({
  "marginBottom": "8px"
});

var _StyledDiv11 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "modal-header___StyledDiv11",
  componentId: "sc-6gq9eh-11"
})({
  "width": "100%"
});

var _StyledDiv12 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "modal-header___StyledDiv12",
  componentId: "sc-6gq9eh-12"
})({
  "display": "flex",
  "paddingLeft": "32px",
  "paddingRight": "32px",
  "paddingTop": "48px",
  "paddingBottom": "24px"
});

var _StyledButton2 = /*#__PURE__*/_styled("button").withConfig({
  displayName: "modal-header___StyledButton2",
  componentId: "sc-6gq9eh-13"
})({
  ":hover": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(243 244 246 / var(--tw-bg-opacity))"
  }
});

var _StyledDiv13 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "modal-header___StyledDiv13",
  componentId: "sc-6gq9eh-14"
})({
  "width": "100%"
});

var _StyledDiv14 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "modal-header___StyledDiv14",
  componentId: "sc-6gq9eh-15"
})({
  "width": "100%"
});